import { Button } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { IAddress } from "../../interfaces";
import * as yup from "yup";
import { Form, Formik } from "formik";
import FormikAwareTextInput from "../../forms/formik/FormikAwareTextInput";

const AddressForm = ({
  address,
  orderEmail = "",
  className = "",
  onCancel,
  onSubmit = () => {},
}: {
  address: IAddress;
  orderEmail?: string;
  className?: string;
  onCancel: () => void;
  onSubmit: (value: IAddress, email?: string) => void; // Anpassung hier
}) => {
  const { t } = useTranslation();

  const SCHEMA = yup.object({
    companyName: yup
      .string()
      .required(`${t("companyName")} ${t("isRequired")}`),
    addressLine1: yup
      .string()
      .required(`${t("address Line1")} ${t("isRequired")}`),
    addressLine2: yup.string().optional(),
    city: yup.string().required(`${t("city")} ${t("isRequired")}`),
    zipCode: yup.string().required(`${t("zipCode")} ${t("isRequired")}`),
    country: yup.string().required(`${t("country")} ${t("isRequired")}`),
    phone: yup.string().required(`${t("phone")} ${t("isRequired")}`),
    email: yup
      .string()
      .email(`${t("invalidEmail")}`)
      .required(`${t("email")} ${t("isRequired")}`),
  });

  return (
    <div className={`w-100 ${className} `}>
      <Formik
        validationSchema={SCHEMA}
        onSubmit={(values) => onSubmit(values, values.email)} // Anpassung hier
        initialValues={{ ...address, email: orderEmail }}
        enableReinitialize
      >
        {({ isValid, isSubmitting }) => (
          <Form className="row row-column space-y-4 ">
            <FormikAwareTextInput
              name="companyName"
              label={`${t("companyName")}:`}
              defaultValue={`${address.companyName}`}
              required
            />
            <FormikAwareTextInput
              name="addressLine1"
              label={`${t("Address Line1")}:`}
              defaultValue={`${address.addressLine1}`}
              required
            />
            <FormikAwareTextInput
              name="addressLine2"
              label={`${t("Address Line2")}:`}
              defaultValue={`${address.addressLine2}`}
            />
            <FormikAwareTextInput
              name="city"
              label={`${t("city")}: `}
              defaultValue={`${address.city}`}
              required
            />
            <FormikAwareTextInput
              name="zipCode"
              label={`${t("zipCode")}:`}
              defaultValue={`${address.zipCode}`}
              required
            />
            <FormikAwareTextInput
              name="country"
              label={`${t("country")}: `}
              defaultValue={`${address.country}`}
              required
            />
            <FormikAwareTextInput
              name="phone"
              label={`${t("phone")}:`}
              defaultValue={`${address.phone}`}
            />
            {/* Neues Feld für die E-Mail hinzufügen */}
            <FormikAwareTextInput
              name="email"
              label={`${t("email")}:`}
              defaultValue={orderEmail}
              required
            />
            <div className="row gap-8 row-column-phone-responsive">
              <Button
                disabled={!isValid || isSubmitting}
                className="modal-outlined-button"
                mt={10}
                size="md"
                fullWidth
                type="submit"
              >
                {t("update")}
              </Button>
              <Button
                mt={10}
                size="md"
                className="modal-outlined-button"
                variant="outline"
                fullWidth
                onClick={onCancel}
              >
                {t("cancel")}
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AddressForm;
